import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { createEntityAdapter } from '../../../helpers/create-entity-adapter';
import { Location } from '../../../interfaces/location.interface';
import { GetLocationsResponse } from '../interfaces/get-locations';

export interface LocationState {
  locations: {
    ids: string[];
    entities: Record<string, Location>;
  };
  location: Location | null;
  page: number;
  size: number;
  total: number;
  noMore: boolean;
  errorCode: number | null;
}

const initialState: LocationState = {
  locations: {
    ids: [],
    entities: {},
  },
  location: null,
  page: 1,
  size: 100,
  total: 0,
  noMore: false,
  errorCode: null,
};

const locationsAdapter = createEntityAdapter<Location>((locations: Location) => locations.id);

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    getLocationsInitApiAction: (state) => {
      state.errorCode = null;
    },
    getLocationsSuccessApiAction: (
      state,
      action: PayloadAction<GetLocationsResponse>
    ) => {
      locationsAdapter.addMany(action.payload.locations, state.locations);
      state.total = action.payload.pagination.total_elements;
      state.page = action.payload.pagination.page;
      state.size = action.payload.pagination.size;
      state.noMore = action.payload.locations.length < state.size;
    },
    getLocationsFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postLocationInitApiAction: (state) => {
      state.errorCode = null;
    },
    postLocationSuccessApiAction: () => {},
    postLocationFailuireApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    putLocationInitApiAction: (state) => {
      state.errorCode = null;
    },
    putLocationSuccessApiAction: () => {},
    putLocationFailuireApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    deleteLocationInitApiAction: () => {},
    deleteLocationSuccessApiAction: () => {},
    deleteLocationFailuireApiAction: () => {},
    setLocationAction: (state, action: PayloadAction<Location | null>) => {
      state.location = action.payload;
    },
    increasePageAction: (state) => {
      state.page += 1;
    },
    resetPageAction: (state) => {
      state.page = 1;
    },
    businessClearAction: (state) => {
      state.location = null;
      state.errorCode = null;
    },
  },
});

export const {
  getLocationsInitApiAction,
  getLocationsSuccessApiAction,
  getLocationsFailureApiAction,
  postLocationInitApiAction,
  postLocationSuccessApiAction,
  postLocationFailuireApiAction,
  putLocationInitApiAction,
  putLocationSuccessApiAction,
  putLocationFailuireApiAction,
  deleteLocationInitApiAction,
  deleteLocationSuccessApiAction,
  deleteLocationFailuireApiAction,
  setLocationAction,
  increasePageAction,
  resetPageAction,
  businessClearAction,
} = locationSlice.actions;

export default locationSlice.reducer;
